import { parseObjectCookie, storeObjectAsCookie } from './object_cookie';

type Test = string;
type Bucket = string;
type Bucketings = Record<Test, { bucket: Bucket; buckets: Bucket[] }>;

export const noticeUnrecordedTest = (
  test: Test,
  buckets: Bucket[],
  bucket: Bucket,
): void => {
  const bucketings = listNoticedUnrecordedTests();
  bucketings[test] = { bucket, buckets };
  setNoticedUnrecordedTests(bucketings);
};

export const unnoticeUnrecordedTest = (test: Test): void => {
  const bucketings = listNoticedUnrecordedTests();
  delete bucketings[test];
  setNoticedUnrecordedTests(bucketings);
};

const setNoticedUnrecordedTests = (bucketings: Bucketings) => {
  storeObjectAsCookie('admin_unrecorded_tests', bucketings);
};

export const listNoticedUnrecordedTests = (): Bucketings => {
  return parseObjectCookie('admin_unrecorded_tests') as Bucketings;
};
